const featurePageExtras = {
  "ad": {
    "faq": [
      [
        "既然 Meta、TikTok、Google 都有自己的官方后台，为什么还需要 XMP？",
        "官方后台只能看到自己渠道的数据，跨平台对比、统一调价、批量编辑都需要在多个后台来回切换。XMP 把 11 个媒体平台整合在一个后台，包括社交媒体 Meta、Google、TikTok、Snapchat、Kwai，设备商媒体 Apple、Petal Ads，以及程序化媒体 AppLovin、Mintegral、Unity、Liftoff，再叠加批量操作和 ROI 视角的调优，适合同时跑多渠道的出海团队。"
      ],
      [
        "多账户、多主体管理在 XMP 里是否安全合规？数据会不会泄漏给其他客户？",
        "XMP 采用账户级数据隔离，不同客户、不同主体的广告账户数据互相不可见。账户授权通过官方 OAuth 完成，XMP 不存储您的媒体平台密码。同时支持账户分组、子账号权限管理，团队成员只能看到被授权的账户范围。"
      ],
      [
        "Excel 批量编辑能改哪些字段？误改之后是否可以回滚？",
        "支持开关、预算、出价、定向、版位、计划状态等核心字段的批量编辑，覆盖 Meta、Google、TikTok 等主流平台。每次批量修改都会记录操作日志，可以追溯修改时间、修改人和修改前后值。部分关键操作（如批量关停）支持二次确认弹窗。"
      ],
      [
        "子渠道价格和开关可以直接调整吗？",
        "可以。XMP 支持在查看 ROI、LTV、留存等后端数据后，直接在页面内完成子渠道开关和价格调整，减少导出、修改、上传 Excel 的反复操作，特别适合 SDK 广告网络的子渠道精细化调优。"
      ],
      [
        "如何接入 AppsFlyer、Adjust、Singular、热力引擎等 MMP？接入大概需要多久？",
        "XMP 支持以上主流 MMP 的 API 对接和 Postback 配置。如果客户已经在 MMP 中开放了 API 权限，标准对接通常 1 小时内完成；如果需要配置 MMP 端的 Postback 规则，通常 2 小时内完成。接入后，买量、归因、变现数据会在 XMP 的统一报表中汇总。"
      ]
    ],
    "logos": [
      {
        "mode": "",
        "items": [
          [
            "assets/customer-logos/apus.png",
            "APUS"
          ],
          [
            "assets/customer-logos/shareit.png",
            "SHAREit"
          ],
          [
            "assets/customer-logos/iqyi.png",
            "iQIYI"
          ],
          [
            "assets/customer-logos/baidu.png",
            "Baidu"
          ],
          [
            "assets/customer-logos/igg.png",
            "IGG"
          ],
          [
            "assets/customer-logos/cmge.png",
            "CMGE"
          ],
          [
            "assets/customer-logos/eyewind.png",
            "EYEWIND"
          ],
          [
            "assets/customer-logos/supercent.png",
            "SUPERCENT"
          ],
          [
            "assets/customer-logos/joypac.png",
            "JoyPac"
          ],
          [
            "assets/customer-logos/junhai.png",
            "JunHai"
          ],
          [
            "assets/customer-logos/gamehaus.png",
            "Gamehaus"
          ],
          [
            "assets/customer-logos/dalanyouxi.png",
            "大蓝游戏"
          ]
        ]
      },
      {
        "mode": "reverse",
        "items": [
          [
            "assets/customer-logos/alictus.png",
            "alictus"
          ],
          [
            "assets/customer-logos/amobear.png",
            "AMOBEAR STUDIO"
          ],
          [
            "assets/customer-logos/auroramob.png",
            "Auroramob"
          ],
          [
            "assets/customer-logos/athree.png",
            "A3"
          ],
          [
            "assets/customer-logos/sofish.png",
            "SOFISH"
          ],
          [
            "assets/customer-logos/hyber.png",
            "HYBER MEDIA"
          ],
          [
            "assets/customer-logos/leiting.png",
            "雷霆游戏"
          ],
          [
            "assets/customer-logos/marature.png",
            "MIRATURE"
          ],
          [
            "assets/customer-logos/mike.png",
            "MIKE GAMES"
          ],
          [
            "assets/customer-logos/mele.png",
            "MELE STUDIO"
          ],
          [
            "assets/customer-logos/hang.png",
            "HANG"
          ],
          [
            "assets/customer-logos/fengkuang.png",
            "疯狂游戏"
          ]
        ]
      },
      {
        "mode": "slow",
        "items": [
          [
            "assets/customer-logos/cpushe.png",
            "CUPSHE"
          ],
          [
            "assets/customer-logos/sinozo.png",
            "星创信息"
          ],
          [
            "assets/customer-logos/master-lex.png",
            "Master Lex"
          ],
          [
            "assets/customer-logos/mib.png",
            "mib"
          ],
          [
            "assets/customer-logos/lunplay.png",
            "LUNPLAY GAME"
          ],
          [
            "assets/customer-logos/papa.png",
            "PaPa"
          ],
          [
            "assets/customer-logos/seven.png",
            "Seven Pirates"
          ],
          [
            "assets/customer-logos/kaixin.png",
            "开心"
          ],
          [
            "assets/customer-logos/tantan.png",
            "探探"
          ],
          [
            "assets/customer-logos/weiyi.png",
            "唯意科技"
          ],
          [
            "assets/customer-logos/xianlai.png",
            "闲徕互娱"
          ],
          [
            "assets/customer-logos/5game.png",
            "5game"
          ]
        ]
      }
    ]
  },
  "batch": {
    "faq": [
      [
        "一次性批量创建几百上千条广告，会被 Meta、TikTok 风控吗？",
        "XMP 的批量创建调用的是各平台的官方 API，并遵循平台开放接口规范。对于大规模创建任务，XMP 会通过创建节奏控制、分批提交和失败重试机制，尽量降低因短时间集中创建带来的限频或审核波动风险。但需要注意，单账户在短时间内创建大量广告时，仍可能触发媒体的日常限频或额外审核，系统会自动延后并提示。"
      ],
      [
        "一次最多可以创建多少个广告？",
        "XMP 支持在 10 个广告账户内同时创建广告。单次任务最多可配置 30 个不同地区设置、30 个不同定向设置、30 个不同预算和出价设置，以及 30 个创意组；结合叉乘、绑定和多账户创建，单次任务可轻松生成超过 10,000 条广告。系统也支持分批提交，以适配不同平台的 API 限制。"
      ],
      [
        "叉乘组合和绑定组合有什么区别？",
        "叉乘组合会生成所有可能的排列组合，例如 3 个国家 × 2 个素材 = 6 个广告，适合大规模测试。绑定组合则是一对一绑定，例如国家 A 绑定素材 1，国家 B 绑定素材 2，只生成 2 个广告，适合有针对性的本地化投放。"
      ],
      [
        "模板复用时，旧账户和新账户的 CBO/ABO 等设置差异会自动适配吗？",
        "会。XMP 在套用模板时会自动检测目标账户的可用预算模式（CBO / ABO）、可用版位、可用 Optimization Goal 等，并将模板里不兼容的字段标红提示。您可以选择\"自动映射到默认值\"或\"手动修改后再创建\"，避免创建出无效广告。"
      ],
      [
        "云端资产库的定向包、标题包可以跨团队共享吗？权限如何控制？",
        "可以。资产库支持团队级、项目级共享，权限分为只读、可使用、可编辑三档。例如，市场团队的定向包可以共享给运营团队\"可使用\"，运营在批量搭建时直接调用，但无法修改原包内容。所有资产共享都有完整的操作日志。"
      ]
    ],
    "logos": [
      {
        "mode": "",
        "items": [
          [
            "assets/customer-logos/igg.png",
            "IGG"
          ],
          [
            "assets/customer-logos/azu.png",
            "AZUR GAMES"
          ],
          [
            "assets/customer-logos/cmge.png",
            "CMGE"
          ],
          [
            "assets/customer-logos/mike.png",
            "MIKE GAMES"
          ],
          [
            "assets/customer-logos/boke.png",
            "BOKE 波克城市"
          ],
          [
            "assets/customer-logos/bingchuan.png",
            "冰川网络"
          ],
          [
            "assets/customer-logos/baochuan.png",
            "宝船科技"
          ],
          [
            "assets/customer-logos/chicheng.png",
            "驰骋游戏"
          ],
          [
            "assets/customer-logos/eyewind.png",
            "EYEWIND"
          ],
          [
            "assets/customer-logos/jichuang.png",
            "疾创网络"
          ],
          [
            "assets/customer-logos/jianchuang.png",
            "简创网络"
          ],
          [
            "assets/customer-logos/jiujiu.png",
            "九九互动"
          ]
        ]
      },
      {
        "mode": "reverse",
        "items": [
          [
            "assets/customer-logos/5game.png",
            "5game"
          ],
          [
            "assets/customer-logos/kaixin.png",
            "开心"
          ],
          [
            "assets/customer-logos/leiting.png",
            "雷霆游戏"
          ],
          [
            "assets/customer-logos/lunplay.png",
            "LUNPLAY GAME"
          ],
          [
            "assets/customer-logos/mele.png",
            "MELE STUDIO"
          ],
          [
            "assets/customer-logos/gamegoing.png",
            "GAME GOING"
          ],
          [
            "assets/customer-logos/papa.png",
            "PaPa"
          ],
          [
            "assets/customer-logos/seven.png",
            "Seven Pirates"
          ],
          [
            "assets/customer-logos/lishu.png",
            "栗树科技"
          ],
          [
            "assets/customer-logos/tantan.png",
            "探探"
          ],
          [
            "assets/customer-logos/tiptop.png",
            "星奇畅想"
          ],
          [
            "assets/customer-logos/touka.png",
            "Touka Games"
          ]
        ]
      },
      {
        "mode": "slow",
        "items": [
          [
            "assets/customer-logos/aplus.png",
            "APLUS"
          ],
          [
            "assets/customer-logos/aidefanqie.png",
            "爱的番茄"
          ],
          [
            "assets/customer-logos/alictus.png",
            "alictus"
          ],
          [
            "assets/customer-logos/joypac.png",
            "JoyPac"
          ],
          [
            "assets/customer-logos/mobplus.png",
            "MOBPLUS"
          ],
          [
            "assets/customer-logos/supercent.png",
            "SUPERCENT"
          ],
          [
            "assets/customer-logos/sinozo.png",
            "星创信息"
          ],
          [
            "assets/customer-logos/junhai.png",
            "JunHai"
          ],
          [
            "assets/customer-logos/gamehaus.png",
            "Gamehaus"
          ],
          [
            "assets/customer-logos/hyber.png",
            "HYBER MEDIA"
          ],
          [
            "assets/customer-logos/athree.png",
            "A3"
          ],
          [
            "assets/customer-logos/sharp.png",
            "Sharp Network"
          ]
        ]
      }
    ]
  },
  "creative": {
    "faq": [
      [
        "素材中心和我现在用的 Google Drive、Dropbox、飞书云盘有什么区别？为什么不能直接用现有工具管理？",
        "Google Drive、Dropbox、飞书云盘更多是素材存储工具，无法把素材和广告投放数据关联起来。XMP 现在也支持接入 Google Drive 和 Dropbox，可直接使用云盘里的素材，同时复用 XMP 强大的标签、评分、筛选、替换和数据分析等能力。除此之外，XMP 素材中心还会自动把每个素材在不同账户、不同广告下的 CTR、CVR、ROAS、留存等表现数据关联并聚合到素材维度，让你能从\"这个素材表现如何\"反推\"我应该复用哪些素材的哪些元素\"。这是普通云盘做不到的。"
      ],
      [
        "素材评分是如何计算的？",
        "素材评分综合考虑了点击率、转化率、ROAS、留存率、LTV 等多个指标，并根据素材的投放量和时间进行加权计算。评分越高，说明素材的综合表现越好。每个客户也可以自定义评分公式的权重，例如更看重 D7 ROAS 而不是 CTR。"
      ],
      [
        "AI 自动打标签的准确率怎么样？人工标签是否可以批量编辑？",
        "AI 标签会从画面元素（人物 / 产品 / 场景 / 文字）、风格（写实 / 卡通 / 真人秀）、节奏（快剪 / 慢节奏）等维度自动打标，帮助团队更快完成素材归类与检索。人工标签支持批量编辑：选中多个素材后可以一次性增删标签，也可以基于现有标签做批量替换。"
      ],
      [
        "素材替换会影响已经投放的广告 ID 和数据连续性吗？",
        "XMP 的素材替换走的是各平台官方支持的替换流程，对已经投放的广告 ID 不会重新生成（除非平台本身要求）。数据连续性方面，XMP 会在素材替换前后做明确的版本标识，报表中可以选择\"按素材版本\"或\"按广告维度\"查看，避免素材切换导致的归因混乱。"
      ],
      [
        "素材报表数据与推广报表数据为什么会有差异？",
        "素材报表统计的是素材维度的数据，一个素材可能被多个广告使用；推广报表统计的是广告维度的数据。此外，数据同步时间差异和归因方式不同也可能导致小幅差异。如果差异超过 5%，建议联系客服核对归因配置。"
      ]
    ],
    "logos": [
      {
        "mode": "",
        "items": [
          [
            "assets/customer-logos/marature.png",
            "MIRATURE"
          ],
          [
            "assets/customer-logos/mobplus.png",
            "MOBPLUS"
          ],
          [
            "assets/customer-logos/olivemedia.png",
            "OLIVE MEDIA"
          ],
          [
            "assets/customer-logos/shiyue.png",
            "诗悦网络"
          ],
          [
            "assets/customer-logos/superstar.png",
            "Super Star Games"
          ],
          [
            "assets/customer-logos/weiyi.png",
            "唯意科技"
          ],
          [
            "assets/customer-logos/wonder.png",
            "Wonder Team"
          ],
          [
            "assets/customer-logos/yingke.png",
            "映客"
          ],
          [
            "assets/customer-logos/youlong.png",
            "游龙互娱"
          ],
          [
            "assets/customer-logos/yuntuhuyu.png",
            "云图互娱"
          ],
          [
            "assets/customer-logos/zhangzhongyun.png",
            "掌中云"
          ],
          [
            "assets/customer-logos/xianlai.png",
            "闲徕互娱"
          ]
        ]
      },
      {
        "mode": "reverse",
        "items": [
          [
            "assets/customer-logos/wuhanduoyou.png",
            "武汉多游"
          ],
          [
            "assets/customer-logos/wtemedia.png",
            "Witemedia"
          ],
          [
            "assets/customer-logos/wawayu.png",
            "旺旺鱼网络科技"
          ],
          [
            "assets/customer-logos/wanxin.png",
            "玩心不止"
          ],
          [
            "assets/customer-logos/flamesdas.png",
            "FlamesAds"
          ],
          [
            "assets/customer-logos/udogame.png",
            "勇往科技"
          ],
          [
            "assets/customer-logos/xx.png",
            "星奇畅想"
          ],
          [
            "assets/customer-logos/quanminhudong.png",
            "全民互动"
          ],
          [
            "assets/customer-logos/afour.png",
            "afour"
          ],
          [
            "assets/customer-logos/vtcmobile.png",
            "VTC Mobile"
          ],
          [
            "assets/customer-logos/ilana.png",
            "ILana"
          ],
          [
            "assets/customer-logos/huayao.png",
            "华曜科技"
          ]
        ]
      },
      {
        "mode": "slow",
        "items": [
          [
            "assets/customer-logos/cpushe.png",
            "CUPSHE"
          ],
          [
            "assets/customer-logos/apus.png",
            "APUS"
          ],
          [
            "assets/customer-logos/dalanyouxi.png",
            "大蓝游戏"
          ],
          [
            "assets/customer-logos/mib.png",
            "mib"
          ],
          [
            "assets/customer-logos/5game.png",
            "5game"
          ],
          [
            "assets/customer-logos/igg.png",
            "IGG"
          ],
          [
            "assets/customer-logos/master-lex.png",
            "Master Lex"
          ],
          [
            "assets/customer-logos/joypac.png",
            "JoyPac"
          ],
          [
            "assets/customer-logos/baidu.png",
            "Baidu"
          ],
          [
            "assets/customer-logos/iqyi.png",
            "iQIYI"
          ],
          [
            "assets/customer-logos/eyewind.png",
            "EYEWIND"
          ],
          [
            "assets/customer-logos/alictus.png",
            "alictus"
          ]
        ]
      }
    ]
  }
};

export default featurePageExtras;
